import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Button, TextField } from "@material-ui/core";
import Selector from "./Selector";
import MaskedInput from "react-text-mask";
import PropTypes from "prop-types";

function TextMaskCustom(props) {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={ref => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[
        "(",
        /[1-9]/,
        /\d/,
        ")",
        " ",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        /\d/
      ]}
      placeholderChar={"\u2000"}
    />
  );
}

TextMaskCustom.propTypes = {
  inputRef: PropTypes.func.isRequired
};

export default ({
  text,
  nome,
  telefone,
  email,
  mensagem,
  handleInputChange,
  setor,
  handleSubmit,
  showLoading,
  showForm
}) => {
  const useStyles = makeStyles({
    root: {
      "& label.Mui-focused": {
        color: "#222"
      },
      "& .MuiInput-underline:after": {
        borderColor: "#58b711",
        borderRadius: 10
      },
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: "#58b711",
          borderRadius: 10
        },
        "&:hover fieldset": {
          borderColor: "#58b711",
          borderRadius: 10
        },
        "&.Mui-focused fieldset": {
          borderColor: "#58b711",
          borderRadius: 10
        }
      }
    },
    button: {
      backgroundColor: "#58b711",
      color: "#fff",
      width: "7vw",
      fontWeight: 600,
      paddingBottom: "1vh",
      paddingTop: "1.2vh",
      paddingLeft: "1vw",
      paddingRight: "1vw",
      borderRadius: 10,
      marginRight: "1.2vw",

      "&:hover": {
        backgroundColor: "#2f7a0a"
      }
    }
  });

  const classes = useStyles();

  return (
    <div>
      <Selector
        text={text}
        setor={setor}
        handleInputChange={handleInputChange}
      />

      <TextField
        label={text.getTextoInput()[0]}
        value={nome}
        classes={{
          root: classes.root
        }}
        margin="normal"
        variant="outlined"
        name="nome"
        fullWidth={true}
        onChange={handleInputChange}
        required={true}
        disabled={showLoading}
      />
      <br />

      <TextField
        label={text.getTextoInput()[1]}
        value={email}
        onChange={handleInputChange}
        classes={{
          root: classes.root
        }}
        margin="normal"
        variant="outlined"
        name="email_from"
        fullWidth={true}
        required={true}
        disabled={showLoading}
      />
      <br />

      <TextField
        label={text.getTextoInput()[2]}
        classes={{
          root: classes.root
        }}
        margin="normal"
        variant="outlined"
        name="telefone"
        fullWidth={true}
        required={true}
        InputProps={{
          inputComponent: TextMaskCustom,
          value: telefone,
          onChange: handleInputChange
        }}
        disabled={showLoading}
      />
      <br />

      <TextField
        fullWidth={true}
        label={text.getTextoInput()[3]}
        multiline
        rowsMax="4"
        value={mensagem}
        onChange={handleInputChange}
        required={true}
        classes={{
          root: classes.root
        }}
        margin="normal"
        variant="outlined"
        name="mensagem"
        style={{ marginBottom: "5vh" }}
        disabled={showLoading}
      />

      <Button className={classes.button} onClick={() => handleSubmit()}>
        Enviar
      </Button>
    </div>
  );
};
